import type { QuizVersion } from '@/core/domain/quiz/QuizVersion.ts'
import { useAuthentication } from '@/presentation/composables/auth/useAuthentication.ts'

export function useQuizAccessUtils() {
  const { isContentApprover } = useAuthentication()
  /**
   * Détermine si la suppression du QuizVersion est possible.
   * @param version
   */
  const canEditQuizVersion = (version: QuizVersion | null): boolean => {
    if (!version) return true
    else if (version.isDraft) return true
    else if (version.isActive) return isContentApprover.value
    return false
  }
  /**
   * Détermine si la suppression du QuizVersion est possible.
   * @param version
   */
  const canPublishQuizVersion = (version: QuizVersion | null): boolean => {
    if (!version) return true
    if (version.isDraft) return isContentApprover.value
    return false
  }

  /**
   * Détermine si la suppression du QuizVersion est possible.
   * @param version
   */
  const canDeleteQuizVersion = (version: QuizVersion | null): boolean => {
    if (!version) return true
    if (version.isDraft) return true
    if (version.isActive) return isContentApprover.value
    return true
  }

  return {
    canEditQuizVersion,
    canPublishQuizVersion,
    canDeleteQuizVersion
  }
}
